<template>
    <button
        role="navigation"
        :class="className"
        :disabled="disabled"
        type="button"
        @click="navigate"
    >
        <span class="SubTab__text"><slot>{{ label }}</slot></span>
    </button>
</template>
<script>
export default {
    name: 'RPSubTab',
    props: {
        label: {
            type: String,
            default: ''
        },
        to: {
            type: Object,
            default: () => ({name: ''}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        className() {
            return `SubTab ${this.isActive
                ? 'SubTab--active'
                : 'SubTab--inactive'}`;
        },
    },
    methods: {
        navigate() {
            if(!this.isActive){
                this.$emit('navigate', this.to);
            }
        }
    }
};
</script>
<style lang="scss">
    .SubTab {
        font-family: proxima-nova, sans-serif;
        padding: 0 0.5rem;
        cursor: pointer;
        background: $white;
        color: $text-grey;
        font-size: 1rem;
        border-radius: 4px;
        border-width: 0;
        white-space: nowrap;
        display: flex;
        &:focus { outline: none; }

        &--active {
            text-align: center;
            cursor: pointer;
            background: transparent;
            color: $highlight-blue;
        }
        &--inactive {
            &:hover {
                background: $grey-50;
            }
            &:disabled{
                cursor: default;
                color: $grey-100;
                background: $white;
            }
        }
    }
</style>
